export class PragmaConstant {
  public static KITS_IMAGE_LOCATION = '/assets/pragma/kits';
  public static KITS_2D_IMAGE_LOCATION = '/assets/images/kits';
  public static KITS_IMAGE_TYPE = 'png';
}
